import React, { useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import "../../settings.styles.css";

import SecurityRoles from "./securityRoles";
import SecurityRoleToUser from "./securityRoleToUser";
import SettingsPanel from "../../components/SettingsPanel";

export default function CompanySecuritySettings() {
  const [activeTab, setActiveTab] = useState("1");

  const Tabs = [
    {
      id: "1",
      name: "Security Roles",
    },
    {
      id: "2",
      name: "Security Role to User",
    },
  ];
  const activeTabPaneContentData = [
    {
      id: "1",
      content: <SecurityRoles page={"securityRoles"} />,
    },
    {
      id: "2",
      content: <SecurityRoleToUser />,
    },
  ];

  return (
    <SettingsPanel
      title="Security Settings"
      description="Security roles and the assignment of those roles to users."
      tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
      value={activeTab}
      onChange={setActiveTab}
    >
      <TabContent activeTab={activeTab} className={"p-1 m-1"}>
        {activeTabPaneContentData.map((item, index) => (
          <TabPane key={index} tabId={item.id}>
            {activeTab === item.id && <div>{item.content}</div>}
          </TabPane>
        ))}
      </TabContent>
    </SettingsPanel>
  );
}
